import React from "react";
import Header from "../common/header";
import OurteamHead from "../layout/our team/ourteam-head";
import OurteamContent from "../layout/our team/ourteam-content";
import Footer from "../common/footer";

function OurTeam() {
    return (
        <div>
            <Header />
            
            <OurteamContent />
            <br />
            <Footer />
        </div>
    );
}

export default OurTeam;